const DEFAULT_API_BASE_URL = "https://api.wherewasi.co.uk";

export const API_BASE_URL = (
  process.env.REACT_APP_API_BASE_URL || DEFAULT_API_BASE_URL
).replace(/\/$/, "");
